import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DocumentEditorType } from '@pt/pt-models';
import { DocResourceStatus } from 'it/primatoo/openapi/api/org/schemas/common/DocResourceStatus';
import {
  AiAssessmentsService,
  AppAssessmentsService,
  BusinessProjectManagementService,
  CovidAssessmentsService,
  GlobalMeasureChecksService,
  TreatmentService
} from '@pt/api-client';

@Component({
  selector: 'pt-document-action-dialog',
  templateUrl: './document-action-dialog.component.html',
  styles: [`
  `]
})
export class DocumentActionDialogComponent {
  public docType: DocumentEditorType;
  public docId: number;
  public action: string;
  public docStatus: DocResourceStatus;

  public title: string;
  public message: string;
  public errorMessage?: string;
  private service: BusinessProjectManagementService;


  constructor(
    public activeModal: NgbActiveModal,
    private aiAssessmentService: AiAssessmentsService,
    private appAssessmentService: AppAssessmentsService,
    private covidAssessmentService: CovidAssessmentsService,
    private globalMeasureCheckService: GlobalMeasureChecksService,
    private treatmentService: TreatmentService
  ) {
  }

  run(docType: DocumentEditorType, docId: number, docStatus: DocResourceStatus, action: 'PUBLISH' | 'REOPEN' | 'VALIDATE') {
    this.docType = docType;
    this.docId = docId;
    this.docStatus = docStatus;
    this.action = action;

    this.populateService(docType);
    this.runAction(action);
  }

  private runPublish() {
    switch (this.docType) {
      case DocumentEditorType.AI_ASSESSMENT:
        this.title = 'TITLE.AI_ASSESSMENT_PUBLISH';
        this.message = 'MESSAGE.AI_ASSESSMENT_PUBLISH';
        break;
      case DocumentEditorType.APP_ASSESSMENT:
        this.title = 'TITLE.APP_ASSESSMENT_PUBLISH';
        this.message = 'MESSAGE.APP_ASSESSMENT_PUBLISH';
        break;
      case DocumentEditorType.COVID_ASSESSMENT:
        this.title = 'TITLE.COVID_ASSESSMENT_PUBLISH';
        this.message = 'MESSAGE.COVID_ASSESSMENT_PUBLISH';
        break;
      case DocumentEditorType.GLOBAL_MEASURE_CHECK:
        this.title = 'TITLE.RISK_ASSESSMENT_PUBLISH';
        this.message = 'MESSAGE.RISK_ASSESSMENT_PUBLISH';
        break;
      case DocumentEditorType.TREATMENT:
        this.title = 'TITLE.TREATMENT_PUBLISH';
        this.message = 'MESSAGE.TREATMENT_PUBLISH';
        break;
      default:
        this.setErrorMessage(`Document type ${this.docType} not supported!`);
    }
  }

  private runReopen() {
    switch (this.docType) {
      case DocumentEditorType.AI_ASSESSMENT:
        this.title = 'TITLE.AI_ASSESSMENT_REOPEN';
        this.message = 'MESSAGE.AI_ASSESSMENT_REOPEN';
        break;
      case DocumentEditorType.APP_ASSESSMENT:
        this.title = 'TITLE.APP_ASSESSMENT_REOPEN';
        this.message = 'MESSAGE.APP_ASSESSMENT_REOPEN';
        break;
      case DocumentEditorType.COVID_ASSESSMENT:
        this.title = 'TITLE.COVID_ASSESSMENT_REOPEN';
        this.message = 'MESSAGE.COVID_ASSESSMENT_REOPEN';
        break;
      case DocumentEditorType.GLOBAL_MEASURE_CHECK:
        this.title = 'TITLE.RISK_ASSESSMENT_REOPEN';
        this.message = 'MESSAGE.RISK_ASSESSMENT_REOPEN';
        break;
      case DocumentEditorType.TREATMENT:
        this.title = 'TITLE.TREATMENT_REOPEN';
        this.message = 'MESSAGE.TREATMENT_REOPEN';
        break;
      default:
        this.setErrorMessage(`Document type ${this.docType} not supported!`);
    }
  }

  private runValidate() {
    switch (this.docType) {
      case DocumentEditorType.AI_ASSESSMENT:
        this.title = 'TITLE.AI_ASSESSMENT_VALIDATE';
        this.message = 'MESSAGE.AI_ASSESSMENT_VALIDATE';
        this.service = this.aiAssessmentService;
        break;
      case DocumentEditorType.APP_ASSESSMENT:
        this.title = 'TITLE.APP_ASSESSMENT_VALIDATE';
        this.message = 'MESSAGE.APP_ASSESSMENT_VALIDATE';
        break;
      case DocumentEditorType.COVID_ASSESSMENT:
        this.title = 'TITLE.COVID_ASSESSMENT_VALIDATE';
        this.message = 'MESSAGE.COVID_ASSESSMENT_VALIDATE';
        break;
      case DocumentEditorType.GLOBAL_MEASURE_CHECK:
        this.title = 'TITLE.RISK_ASSESSMENT_VALIDATE';
        this.message = 'MESSAGE.RISK_ASSESSMENT_VALIDATE';
        break;
      case DocumentEditorType.TREATMENT:
        this.title = 'TITLE.TREATMENT_VALIDATE';
        this.message = 'MESSAGE.TREATMENT_VALIDATE';
        break;
      default:
        this.setErrorMessage(`Document type ${this.docType} not supported!`);
    }
  }

  public confirm() {
    switch (this.action) {
      case 'PUBLISH':
        this.publishConfirmed();
        break;
      case 'REOPEN':
        this.reopenConfirmed();
        break;
      case 'VALIDATE':
        this.validateConfirmed();
        break;
    }
  }

  private publishConfirmed() {
    this.service.publish(this.docId).subscribe(() => {
      this.activeModal.close(true);
    }, (error: { error: {reason: string, data: any } }) => {
      this.errorMessage = error?.error?.reason;
      console.error('Error ', error);
    });
  }

  private reopenConfirmed() {
    this.service.reopen(this.docId).subscribe(() => {
      this.activeModal.close(true);
    }, (error: { error: {reason: string, data: any } }) => {
      this.errorMessage = error?.error?.reason;
      console.error('Error ', error);
    });
  }

  private validateConfirmed() {
    console.error('ERROR: Validazione non implementata in questo flusso')
    this.setErrorMessage('Validazione non implementata in questo flusso');
    // const request: ValidateDocumentRequest = {
    //   name: "Request",
    //   description: "Description"
    // }
    // this.service.validate(this.docId).subscribe(() => {
    // this.activeModal.close(true);
    // }, (error: { reason: string }) => {
    // })
  }

  private populateService(docType: DocumentEditorType) {
    switch (docType) {
      case DocumentEditorType.AI_ASSESSMENT:
        this.service = this.aiAssessmentService;
        break;
      case DocumentEditorType.APP_ASSESSMENT:
        this.service = this.appAssessmentService;
        break;
      case DocumentEditorType.COVID_ASSESSMENT:
        this.service = this.covidAssessmentService;
        break;
      case DocumentEditorType.GLOBAL_MEASURE_CHECK:
        this.service = this.globalMeasureCheckService;
        break;
      case DocumentEditorType.TREATMENT:
        this.service = this.treatmentService;
        break;
      default:
        this.setErrorMessage(`Document type ${this.docType} not supported!`);
    }
  }

  private setErrorMessage(message: string) {
    this.errorMessage = message;
  }

  private runAction(action: 'PUBLISH' | 'REOPEN' | 'VALIDATE') {
    switch (action) {
      case 'PUBLISH':
        this.runPublish();
        break;
      case 'REOPEN':
        this.runReopen();
        break;
      case 'VALIDATE':
        this.runValidate();
        break;
      default:
        this.setErrorMessage(`Action ${action} not supported!`);
    }
  }
}
